const DELIVERED = 'delivered';
const IN_TRANSIT = 'inTransit';
const LOST = 'lost';
const REJECTED = 'rejected';
const STORED = 'stored';
const TO_PICKUP = 'toPickup';
const RETURNED = 'returned';

const BAG_STATUS = {
  DELIVERED,
  IN_TRANSIT,
  LOST,
  REJECTED,
  STORED,
  TO_PICKUP,
  RETURNED,
} as const;

export type BagStatus = typeof BAG_STATUS;

export default BAG_STATUS;
